export const StatusBarViewGrid = {
	size: 100,
	gap: 0,
	name: 'statusbar0',
	// background: {
	// 	element: 'status_bar_bg',
	// 	main: {
	// 		height: 7.5,
	// 		align: 'bg'
	// 	},
	// 	portrate: {
	// 		height: 6.5,
	// 		align: 'bottom'
	// 	},
	// 	landscape: {
	// 		height: 12,
	// 		align: 'bg'
	// 	}
	// },
	padding: {
		left: 5,
		right: 5,
		portrate: {
			left: 3,
			right: 3
		},
		landscape: {
			left: 5,
			right: 5
		}
	},
	main: [
		{
			name: 'empty',
			size: 3
		},
		// {
		// 	name: 'status_bar_bg',
		// 	visible: false
		// },
		{
			name: 'statusbar1',
			size: 97,
			type: 'PortrateGridController',
			config: {
				name: 'statusbar2',
				size: 100,
				gap: 0,
				align: 'left',
				main: [
					{
						name: 'empty',
						size: 85
					},
					{
						name: 'statusbar3',
						type: 'LandscapeGridController',
						size: 6,
						config: {
							size: 100,
							gap: 0,
							name: 'statusbar4',
							main: [
								{
									name: 'Balance',
									size: 30,
									align: 'left_center',
									height: 40,
									bounds: {
										width: 70,
										height: 20
									}
								},
								{
									name: 'empty',
									size: 35
								}
								// {
								// 	name: 'COPY',
								// 	size: 35,
								// 	align: 'center',
								// 	height: 40
								// }
							]
						}
					}
				]
			}
		}
	],
	portrate: [
		{
			name: 'empty',
			size: 94
		},
		{
			name: 'statusbar5',
			type: 'LandscapeGridController',
			size: 6,
			config: {
				size: 90,
				gap: 0,
				maxWidth: 'reel',
				name: 'statusbar6',
				// hide: ['status_bar_bg'],
				main: [
					{
						name: 'Balance',
						size: 30,
						align: 'left_center',
						bounds: {
							width: 12,
							height: 60
						}
					},

					{
						name: 'empty',
						size: 30
					}
					// {
					// 	name: 'COPY',
					// 	size: 30,
					// 	align: 'center'
					// }

					// {
					//   name: "WinAmount",
					//   size: 30,
					//   align: "right_center",
					//   height: 40
					// },
				]
			}
		}
	],
	landscape: [
		{
			name: 'statusbar7',
			size: 100,
			type: 'PortrateGridController',
			config: {
				name: 'statusbar8',
				size: 100,
				gap: 0,
				// unhide: ['status_bar_bg'],
				main: [
					{
						name: 'empty',
						size: 94
					},
					{
						name: 'statusbar9',
						type: 'LandscapeGridController',
						size: 6,
						config: {
							size: 100,
							gap: 0,
							name: 'statusbar10',
							main: [
								{
									name: 'Balance',
									size: 33,
									align: 'left_center',
									height: 40,
									bounds: {
										width: 50,
										height: 20
									}
								},
								{
									name: 'empty',
									size: 33
								},
								// {
								// 	name: 'COPY',
								// 	size: 33,
								// 	align: 'center',
								// 	height: 40
								// },
								{
									name: 'WinAmount',
									size: 33,
									align: 'right_center',
									height: 40
								}
							]
						}
					}
				]
			}
		}
	]
};
